import React, { FunctionComponent } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Styles from './HelpLeftNavBar.module.scss';

interface HelpLeftNavBarProps {
  onLinkClick?: () => void;
}

const HelpLeftNavBar: FunctionComponent<HelpLeftNavBarProps> = ({ onLinkClick }) => {
  const location = useLocation();
  const path = location.pathname;

  const handleClick = () => {
    if (onLinkClick) {
      onLinkClick();
    }
  };

  return (
    <>
      <ul className={`list-unstyled ${Styles.listingWrapper}`}>
        <li className={`fontSixteen text-black poppins-bold ${Styles.listingTitle}`}>LOCATION HELP</li>
        <li className={`${path === '/help/browser-settings' && Styles.active}`}>
          <Link className="fontFifteen poppins-regular text-decoration-none" to="/help/browser-settings" onClick={handleClick}>
            Step 1: Browser Settings
          </Link>
        </li>
        <li className={`${path === '/help/os-privacy-settings' && Styles.active}`}>
          <Link className="fontFifteen poppins-regular text-decoration-none" to="/help/os-privacy-settings" onClick={handleClick}>
            Step 2: OS Privacy Settings
          </Link>
        </li>
        
        <li className={`fontSixteen text-black poppins-bold ${Styles.listingTitle} ${Styles.sectionSpacing}`}>NOTIFICATIONS</li>
        <li className={`${path === '/help/notification-settings' && Styles.active}`}>
          <Link className="fontFifteen poppins-regular text-decoration-none" to="/help/notification-settings" onClick={handleClick}>
            Turn Off Notifications
          </Link>
        </li>
      </ul>
    </>
  );
};

export default HelpLeftNavBar;